export const US_STATES = [
  {
    name: 'Alabama',
    abbreviation: 'AL',
    format: '^\\d{7}$',
  },
  {
    name: 'Alaska',
    abbreviation: 'AK',
    format: '^\\d{7}$',
  },
  {
    name: 'American Samoa',
    abbreviation: 'AS',
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
    format: '^[\\w\\d]\\d{8}$',
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
    format: '^9\\d{8}$',
  },
  {
    name: 'California',
    abbreviation: 'CA',
    format: '^\\w\\d{7}$',
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
    format: '^\\d{2}-\\d{3}-\\d{4}$',
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
    format: '^\\d{9}$',
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
    format: '^\\d{7}$',
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC',
    format: '^\\d{7}$',
  },
  {
    name: 'Federated States Of Micronesia',
    abbreviation: 'FM',
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
    format: '^\\w\\d{12}$',
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
    format:
      '^(\\w\\d{12}|\\w\\d{3}-\\d{3}-\\d{2}-\\d{3}-\\d{1}|\\w\\d{3}-\\d{3}-\\d{3}-\\d{3})$',
  },
  {
    name: 'Guam',
    abbreviation: 'GU',
    format: '^\\d{9}$',
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
    format: '^\\w\\d{8}$',
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
    format: '^\\w{2}\\d{6}\\w$',
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
    format: '^\\w(\\d{3}-\\d{4}-\\d{4}|\\d{11})$',
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
    format: '^\\d{4}-\\d{2}-\\d{4}$',
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
    format: '^(\\d{9}|\\d{3}\\w{2}\\d{4})$',
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
    format: '^\\w\\d{2}-\\d{2}-\\d{4}$',
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
    format: '^\\w\\d{2}-\\d{3}-\\d{3}$',
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
    format: '^\\d{9}$',
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
    format: '^\\d{7}$',
  },
  {
    name: 'Marshall Islands',
    abbreviation: 'MH',
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
    format: '^\\w(\\d{12}|-\\d{3}-\\d{3}-\\d{3}-\\d{3})$',
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
    format: '^\\w\\d{9}$',
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
    format: '^\\w(\\d{12}|\\s\\d{3}\\s\\d{3}\\s\\d{3}\\s\\d{3})$',
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
    format: '^\\w\\d{12}$',
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
    format: '^\\d{3}-\\d{2}-\\d{4}$',
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
    format: '^\\w\\d{9}$',
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
    format:
      '^(\\d{9}|(0[1-9]|1[0-2])\\d{3}(19\\d{2}|[2-9]\\d{3})41(0[1-9]|[1-2]\\d|3[0,1]))$',
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
    format: '^\\w\\d{8}$',
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
    format: '^\\d{10}$',
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
    format: '^(0[1-9]|1[0-2])\\w{3}\\d{2}(0[1-9]|[1-2]\\d|3[0,1])\\d$',
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
    format: '^\\w(\\d{4}-\\d{5}-\\d{5}|\\d{14})$',
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
    format: '^\\d{9}$',
  },
  {
    name: 'New York',
    abbreviation: 'NY',
    format: '^(\\d{9}|\\d{3}\\s\\d{3}\\s\\d{3})$',
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
    format: '^\\d{12}$',
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
    format: '^\\w{3}-\\d{2}-\\d{4}$',
  },
  {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP',
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
    format: '^\\w{2}\\d{6}$',
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
    format: '^\\w\\d{9}$',
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
    format: '^\\d{7}$',
  },
  {
    name: 'Palau',
    abbreviation: 'PW',
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
    format: '^\\d{2}\\s\\d{3}\\s\\d{3}$',
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR',
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
    format: '^[1-9]{2}\\d{5}$',
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
    format: '^\\d{9}$',
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
    format: '^\\d{8}$',
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
    format: '^\\d{8,9}$',
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
    format: '^\\d{8}$',
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
    format: '^\\d{9}$',
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
    format: '^(\\d{8}|\\d{7}\\w)$',
  },
  {
    name: 'Virgin Islands',
    abbreviation: 'VI',
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
    format: '^\\w(\\d{8}|\\d{2}-\\d{2}-\\d{4})$',
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
    format: '^\\w{3}\\*\\*\\w{2}\\d{3}\\w\\d$',
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
    format: '^[\\w\\d]\\d{6}$',
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
    format: '^\\w\\d{3}-\\d{4}-\\d{4}-\\d{2}$',
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
    format: '^\\d{6}-\\d{3}$',
  },
  {
    name: 'Alberta',
    abbreviation: 'AB',
  },
  {
    name: 'British Columbia',
    abbreviation: 'BC',
  },
  {
    name: 'Manitoba',
    abbreviation: 'MB',
  },
  {
    name: 'New Brunswick',
    abbreviation: 'NB',
  },
  {
    name: 'Newfoundland',
    abbreviation: 'NF',
  },
  {
    name: 'Nova Scotia',
    abbreviation: 'NS',
  },
  {
    name: 'Northwest Territories',
    abbreviation: 'NT',
  },
  {
    name: 'Ontario',
    abbreviation: 'ON',
  },
  {
    name: 'Prince Edward Island',
    abbreviation: 'PE',
  },
  {
    name: 'Quebec',
    abbreviation: 'QC',
  },
  {
    name: 'Saskatchewan',
    abbreviation: 'SK',
  },
  {
    name: 'Yukon Territory',
    abbreviation: 'YT',
  },
];
